import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { StorageUtil } from './storage-util';
import { Language } from '../constants/language';
import { SEOUtil } from './seo-util';

import enCommon from '../localization/en/common.json';
import arCommon from '../localization/ar/common.json';

const resources = {
  en: {
    common: enCommon,
  },
  ar: {
    common: arCommon,
  },
};

// Get initial language directly from storage, with fallback
const getInitialLanguage = (): Language => {
  // Try to get from configuration first
  const configLanguage = StorageUtil.getString(StorageUtil.KEYS.LANGUAGE, '');
  if (configLanguage && (configLanguage === Language.EN || configLanguage === Language.AR)) {
    return configLanguage as Language;
  }
  
  // Try to get from i18next's own storage
  const i18nextLang = StorageUtil.getString('i18nextLng', '');
  if (i18nextLang && (i18nextLang === Language.EN || i18nextLang === Language.AR)) {
    return i18nextLang as Language;
  }
  
  // Default to Arabic
  return Language.AR;
};

const initialLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false,
    },
    
    defaultNS: 'common',
    
    react: {
      useSuspense: false,
    },
  });

// Set initial document direction
document.documentElement.dir = initialLanguage === 'ar' ? 'rtl' : 'ltr';

// Set initial SEO language
SEOUtil.setLanguage(initialLanguage);

// Listen for language changes and update SEO
i18n.on('languageChanged', (lng: string) => {
  SEOUtil.setLanguage(lng as Language);
});

export default i18n;